export default __webpack_public_path__ + "total-staff-purple-icon.svg";